import React, { useState, useEffect, useRef } from 'react'
import HeadingArea from '../../general/HeadingArea'
import { AiOutlineSearch } from 'react-icons/ai';
import { FaPrint } from 'react-icons/fa';
import ResponseMsg2 from '../../general/ResponseMsg2';

const Payroll = ({ setLoading, userData }) => {
  const [selectedRole, setSelectedRole] = useState("");
  const [response2, setResponse2] = useState({ message: '', status: 'success' });
const [payroll, setPayroll] = useState([]);
    const [report, setReport] = useState([]);
    const [academicYears, setAcademicYears] = useState([]);
    const [showGenerate, setShowGenerate] = useState(false);
    const [showView, setShowView] = useState(false);
    const [selectedEmp, setSelectedEmp] = useState('');
    const [selectedAY, setSelectedAY] = useState('');
    const [selectedPayroll, setSelectedPayroll] = useState('');
    const [selectedMonth, setSelectedMonth] = useState('');
    const months = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
    ];

    const fetchAcademicYears = async () => {
        setLoading(true);
        try {
            const response = await fetch('https://api.kcian.in/get-academic-years');
            if (response.ok) {
                const data = await response.json();
                const sortedData = data.sort((a, b) => b.id - a.id);
                setAcademicYears(sortedData);
            } else {
                console.error('Failed to fetch academic years');
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    };


        const fetchPayroll = async () => {
        setLoading(true);

                    const params = new URLSearchParams();
            params.append('year', selectedAY);
            params.append('month', selectedMonth);


        try {
            const response = await fetch(`https://api.kcian.in/get-payroll?${params.toString()}`);
            if (response.ok) {
                const data = await response.json();
                console.log(data);
                setPayroll(data);
            } else {
                console.error('Failed to fetch academic years');
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    };

    // Initial fetches for classes and academic years
    useEffect(() => {   
        fetchAcademicYears();
    }, []);

    const handleSearch = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {

            const params = new URLSearchParams();
            params.append('ay', selectedAY);
            params.append('month', selectedMonth);
params.append('role', userData.role == 'SupAdmin' ? selectedRole : userData.role);

            const url = `https://api.kcian.in/get-staffatd-report?${params.toString()}`;

            const response = await fetch(url);

            if (response.ok) {
                const resData = await response.json();

                let data = resData;
if (userData.role != 'SupAdmin') {
  data = resData.filter(item => item.user_id == userData.user_id);
}

console.log(data);
                setReport(data);
                fetchPayroll();
            } else {
                console.error('Failed to fetch students atd report');
            }
        } catch (error) {
            console.error('Error fetching students atd report:', error);
        } finally {
            setLoading(false);
        }
    };



    const printRef = useRef();


// const handlePrint = () => {
//   if (!printRef.current) return;

//   const printContents = printRef.current.innerHTML;

//   const printWindow = window.open('', '', 'height=600,width=800');
//   printWindow.document.write('<html><head><title>Student Attendance Report</title>');

//   printWindow.document.write('<style>');
//   printWindow.document.write(`
//     html, body {
//       margin: 0;
//       padding: 0;
//     }
//     table {
//       border-collapse: collapse;
//     }
//     th, td {
//       border: 1px solid #000;
//       padding: 5px;
//       text-align: center;
//       white-space: nowrap;
//     }
//     th {
//       background-color: #f0f0f0;
//     }
//     .profile-btn2 {
//       display: none;
//     }
//     .profile-heading {
//       font-size: 18px;
//       font-weight: bold;
//       margin-bottom: 15px;
//     }
//        @page {
//       margin: 2px;
//     }
//   `);
//   printWindow.document.write('</style>');

//   printWindow.document.write('</head><body>');
//   printWindow.document.write(printContents);
//   printWindow.document.write('</body></html>');

//   printWindow.document.close();
//   printWindow.focus();

//   printWindow.print();
//   printWindow.close();
// };

  
const getAllDatesInMonth = (monthName, year) => {
  const monthIndex = months.indexOf(monthName);
  const dates = [];
  const totalDays = new Date(year, monthIndex + 1, 0).getDate();

  for (let day = 1; day <= totalDays; day++) {
    const dayStr = day.toString().padStart(2, '0');
    const monthStr = (monthIndex + 1).toString().padStart(2, '0');
    dates.push(`${year}-${monthStr}-${dayStr}`);
  }

  return dates;
};

const allDates = selectedMonth && selectedAY
  ? getAllDatesInMonth(selectedMonth, selectedAY)
  : [];


  const handleShow = (data) => {
setShowGenerate(true);
setSelectedEmp(data);
  }


  const handleShowView = (matchedPayroll, data) => {
setShowView(true);
setSelectedPayroll({
  ...matchedPayroll,
  earning: JSON.parse(matchedPayroll.earning || '[]'),
  deduction: JSON.parse(matchedPayroll.deduction || '[]')
});
setSelectedEmp(data);
  }



  const [additionalEarnings, setAdditionalEarnings] = useState([
    { description: '', amount: '' }
  ]);
  const [additionalDeductions, setAdditionalDeductions] = useState([
    { description: '', amount: '' }
  ]);
  const [leaveDeduction, setLeaveDeduction] = useState('');

  // Calculate sum helpers
  const sumEarnings = additionalEarnings.reduce(
    (acc, curr) => acc + (parseFloat(curr.amount) || 0), 0
  );

  const sumDeductions = additionalDeductions.reduce(
    (acc, curr) => acc + (parseFloat(curr.amount) || 0), 0
  );

  // Calculate net salary
  const netSalary = selectedEmp
    ? (parseFloat(selectedEmp.staff_salary) || 0) + sumEarnings - sumDeductions - (parseFloat(leaveDeduction) || 0)
    : 0;

  // Handlers for dynamic fields
  const handleAddEarning = () => {
    setAdditionalEarnings([...additionalEarnings, { description: '', amount: '' }]);
  };

  const handleRemoveEarning = (index) => {
    const newEarnings = [...additionalEarnings];
    newEarnings.splice(index, 1);
    setAdditionalEarnings(newEarnings);
  };

  const handleEarningChange = (index, field, value) => {
    const newEarnings = [...additionalEarnings];
    newEarnings[index][field] = value;
    setAdditionalEarnings(newEarnings);
  };

  const handleAddDeduction = () => {
    setAdditionalDeductions([...additionalDeductions, { description: '', amount: '' }]);
  };

  const handleRemoveDeduction = (index) => {
    const newDeductions = [...additionalDeductions];
    newDeductions.splice(index, 1);
    setAdditionalDeductions(newDeductions);
  };

  const handleDeductionChange = (index, field, value) => {
    const newDeductions = [...additionalDeductions];
    newDeductions[index][field] = value;
    setAdditionalDeductions(newDeductions);
  };

  // Submit payroll data to backend
  const handleSubmitPayroll = async () => {
    if (!selectedEmp) return;

    setLoading(true);

    try {
      const payload = {
        emp_id: selectedEmp.user_id,
        earning: additionalEarnings.filter(e => e.description && e.amount),
        deduction: additionalDeductions.filter(d => d.description && d.amount),
        leave_deduction: leaveDeduction || 0,
        net_salary: netSalary,
        status: 'Generated',
        month: selectedMonth,
        year: selectedAY,
      };

      const response = await fetch('https://api.kcian.in/save-payroll', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
    setResponse2({ message: 'Payroll Generated Successfully!', status: 'success' });
        setShowGenerate(false);
        setAdditionalEarnings([{ description: '', amount: '' }]);
        setAdditionalDeductions([{ description: '', amount: '' }]);
        setLeaveDeduction('');
      } else {
                setResponse2({ message: 'Something Went Wrong. Please try again.', status: 'error' });
      }
    } catch (error) {
      console.error('Error saving payroll:', error);
    //   alert('Error saving payroll.');
    } finally {
        setTimeout(() => {
          setResponse2('');
        }, 3000);   
      setLoading(false);
    }
  };

  

      const formatDate = (dateString) => {
        const date = new Date(dateString);

        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();

        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");

        return `${day}-${month}-${year} `;
    };



    return (
        <>
            <section className='py-4'>
                <div className='px-4'>
                    <HeadingArea message1='HR' message2='Payroll' />

       {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />}

                    <form onSubmit={handleSearch} className='profile-card'>
                        <span className="profile-heading">Select Criteria</span>

                        <div className='row mt-3'>

                            <div className="col-lg-4 col-md-6 col-6 mb-4">
                                <div className='profile-input-area'>
                                    <label className="profile-badge">Select AY*</label>
                                    <select
                                        className="profile-input"
                                        value={selectedAY}
                                        onChange={(e) => setSelectedAY(e.target.value)}
                                        required
                                    >
                                        <option value="">-- Select Academic Year --</option>
                                        {academicYears.map((ay) => (
                                            <option key={ay.year} value={ay.year}>
                                                {ay.year} --- {ay.title}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>


                            <div className="col-lg-4 col-md-6 col-6 mb-4">
                                <div className='profile-input-area'>
                                    <label className="profile-badge">Select Month*</label>
                                    <select
                                        className="profile-input"
                                        value={selectedMonth}
                                        onChange={(e) => setSelectedMonth(e.target.value)}
                                        required
                                    >
                                        <option value="">-- Select Month --</option>
                                        {months.map((month, idx) => (
                                            <option key={idx} value={month}>
                                                {month}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>

{userData.role == 'SupAdmin' &&
              <div className="col-lg-4 col-md-6 col-6 mb-4">
                <div className='profile-input-area'>
                  <label className="profile-badge">Select Role*</label>
                  <select
                    className="profile-input"
                    value={selectedRole}
                    onChange={(e) => setSelectedRole(e.target.value)}
                    // required
                  >
                    <option value="">-- Select Role --</option>
                    <option value="Teacher">Teacher</option>
                    <option value="Librarian">Librarian</option>
                    <option value="Accountant">Accountant</option>
                    <option value="Driver">Driver</option>
                    <option value="Other">Other</option>
                  </select>
                </div>
              </div>
}



                        </div>
                        {/* flex ends */}


                        <div className='text-end'>
                            <button type='submit' className='profile-btn2'>
                                <AiOutlineSearch /> Search
                            </button>
                        </div>
                    </form>
                    {/* form ends */}


                    <div className='profile-card mt-3' ref={printRef}>

                        
                        <span className="profile-heading">Staff List - {selectedRole} {selectedMonth} {selectedAY}</span>

{/* <div className='text-end'>
                            <button type='submit' className='profile-btn2' onClick={handlePrint}>
                                <FaPrint /> Print
                            </button></div> */}

<p className='text-muted'>Present: P Absent: A Leave: L Holiday: H Half Day: F</p>
            <div className='table-responsive mb-3'>
<table className='w-100'>
<thead className='account-thead'>
  <tr>
    <th className='rounded-start-4'>Reg No</th>
    <th>Name</th>
    <th>P</th>
    <th>A</th>
    <th>L</th>
    <th>H</th>
    <th>F</th>
    <th>%</th>
    <th className='rounded-end-4'>Activity</th>
{/* {allDates.map(date => (
  <th key={date} className='text-nowrap'>{new Date(date).getDate()}</th>
))}
    <th>Note</th> */}
  </tr>
</thead>

<tbody>
  {report.length === 0 ? (
    <tr className='text-center account-tr'>
      <td colSpan="100%">No Student Data found</td>
    </tr>
  ) : (() => {
    const grouped = {};

    // Group by student_id
    report.forEach(rpt => {
      const id = rpt.uId;
      if (!grouped[id]) {
        grouped[id] = {
          staff_name: rpt.staff_name,
          staff_designation: rpt.staff_designation,
          staff_salary: rpt.staff_salary,
          staff_role: rpt.role,
          user_id: rpt.user_id,
          dates: {},
          present: 0,
          absent: 0,
          leave: 0,
          halfDay: 0,
          holiday: 0,
          note: rpt.note,
        };
      }

      const mark = rpt.mark;

if (mark === 'Present') grouped[id].present += 1;
else if (mark === 'Absent') grouped[id].absent += 1;
else if (mark === 'Leave') grouped[id].leave += 1;
else if (mark === 'Half Day') grouped[id].halfDay += 1;
else if (mark === 'Holiday') grouped[id].holiday += 1;

const markShortCodes = {
  'Present': 'P',
  'Absent': 'A',
  'Leave': 'L',
  'Holiday': 'H',
  'Half Day': 'F'
};

grouped[id].dates[rpt.date] = markShortCodes[mark] || '';

    });

    return Object.entries(grouped).map(([id, data], index) => (
      <tr key={index} className='account-tr'>
        <td className='border-bottom'>{data.user_id}</td>
        <td className='border-bottom'>{data.staff_name}<br />({data.staff_designation})</td>
        <td className='border-bottom'>{data.present}</td>
        <td className='border-bottom'>{data.absent}</td>
        <td className='border-bottom'>{data.leave}</td>
        <td className='border-bottom'>{data.holiday}</td>
        <td className='border-bottom'>{data.halfDay}</td>
<td className='border-bottom'>
  {(
    ((data.present + data.holiday + 0.5 * data.halfDay) / 
     (data.present + data.holiday + data.absent + data.leave + data.halfDay)
    ) * 100
  ).toFixed(1)}%
</td>
<td className='py-3 cursor-pointer'>
  {!payroll.some(p => p.emp_id === data.user_id) ? (
    <span className='profile-btn2' onClick={() => handleShow(data)}>
      Generate Payroll
    </span>
  ) : (
    <span
      className='profile-btn2'
      onClick={() => {
        const matchedPayroll = payroll.find(p => p.emp_id === data.user_id);
        handleShowView(matchedPayroll, data);
      }}
    >
      View Payroll
    </span>
  )}
</td>

{/* {allDates.map(date => (
  <td className='border' key={date}>{data.dates[date] || ''}</td>
))} */}
        {/* <td className='border'>{data.note}</td> */}
      </tr>
    ));
  })()}
</tbody>



</table>
</div>


                    </div>
{/* report ends */}


                </div>
            </section>


{showGenerate && (
        <section
          className="ins-dialog"
          onClick={() => setShowGenerate(false)}
        >
          <div
            className="ins-dialog-inner col-lg-10 col-12 animate__animated animate__fadeInDown mx-auto"
            onClick={(e) => e.stopPropagation()}
          >
            <p className="ins-dialog-heading text-danger">Payroll Details</p>

            <table className="w-100">
              <tbody>
                <tr className="account-tr">
                  <td colSpan={3}>Employee Id: {selectedEmp.user_id}</td>
                  <td colSpan={3}>Employee Name: {selectedEmp.staff_name}</td>
                </tr>

                <tr className="account-tr">
                  <td colSpan={3}>Employee Role: {selectedEmp.staff_role}</td>
                  <td colSpan={3}>Designation: {selectedEmp.staff_designation}</td>
                </tr>

                <tr className="account-tr">
                  <td colSpan={6}>Salary: ₹{selectedEmp.staff_salary}</td>
                </tr>

                <tr className="account-tr">
                  <td>Present</td>
                  <td>Absent</td>
                  <td>Leave</td>
                  <td>Holiday</td>
                  <td>Half Day</td>
                  <td>%</td>
                </tr>

                <tr className="account-tr">
                  <td>{selectedEmp.present}</td>
                  <td>{selectedEmp.absent}</td>
                  <td>{selectedEmp.leave}</td>
                  <td>{selectedEmp.holiday}</td>
                  <td>{selectedEmp.halfDay}</td>
                  <td>
                    {(
                      ((selectedEmp.present + selectedEmp.holiday + 0.5 * selectedEmp.halfDay) /
                        (selectedEmp.present +
                          selectedEmp.holiday +
                          selectedEmp.absent +
                          selectedEmp.leave +
                          selectedEmp.halfDay)) *
                      100
                    ).toFixed(1)}
                    %
                  </td>
                </tr>
              </tbody>
            </table>

            {/* Additional Earnings Section */}
            <p className='profile-heading mt-4'>Additional Earnings</p>
            {additionalEarnings.map((earning, idx) => (

              <div key={idx} className="d-flex mb-2 align-items-center gap-2">
                <div className='profile-input-area'>
                <input
                  type="text"
                  placeholder="Description"
                  value={earning.description}
                  onChange={(e) => handleEarningChange(idx, 'description', e.target.value)}
                  className="profile-input"
                />
                </div>

                <div className='profile-input-area'>
                <input
                  type="number"
                  placeholder="Amount"
                  value={earning.amount}
                  onChange={(e) => handleEarningChange(idx, 'amount', e.target.value)}
                  className="profile-input"
                  min="0"
                />
                </div>
                {additionalEarnings.length > 1 && (
                  <button
                    type="button"
                    className="profile-btn2"
                    onClick={() => handleRemoveEarning(idx)}
                  >
                    Remove
                  </button>
                )}
              </div>
            ))}
            <button type="button" className="profile-btn my-3" onClick={handleAddEarning}>
              + Add More
            </button>

            {/* Additional Deductions Section */}
            <h5>Additional Deductions</h5>
            {additionalDeductions.map((deduction, idx) => (
              <div key={idx} className="d-flex mb-2 align-items-center gap-2">

                <div className='profile-input-area'>
                <input
                  type="text"
                  placeholder="Description"
                  value={deduction.description}
                  onChange={(e) => handleDeductionChange(idx, 'description', e.target.value)}
                  className="profile-input"
                />
                </div>

                <div className='profile-input-area'>
                <input
                  type="number"
                  placeholder="Amount"
                  value={deduction.amount}
                  onChange={(e) => handleDeductionChange(idx, 'amount', e.target.value)}
                  className="profile-input"
                  min="0"
                />
                </div>

                {additionalDeductions.length > 1 && (
                  <button
                    type="button"
                    className="profile-btn2"
                    onClick={() => handleRemoveDeduction(idx)}
                  >
                    Remove
                  </button>
                )}
              </div>
            ))}
            <button type="button" className="profile-btn2 my-3" onClick={handleAddDeduction}>
              + Add More
            </button>

            {/* Leave Deduction Input */}
            <div className="profile-input-area my-4">
              <label className="profile-badge">Leave Deduction (₹)</label>
              <input
                type="number"
                className="profile-input"
                value={leaveDeduction}
                min="0"
                onChange={(e) => setLeaveDeduction(e.target.value)}
                placeholder="Enter leave deduction amount"
              />
            </div>

            {/* Net Salary Display */}
            <div className="mb-3">
              <strong>Net Salary: ₹{netSalary.toFixed(2)}</strong>
            </div>

            {/* Submit Button */}
            <button className="profile-btn me-2" onClick={handleSubmitPayroll}>
              Submit Payroll
            </button>

            <button className="profile-btn2" onClick={() => setShowGenerate(false)}>
              Go Back
            </button>
          </div>
        </section>
      )}


{showView && (
    <>
        <section
          className="ins-dialog"
          onClick={() => setShowGenerate(false)}
        >
          <div
            className="ins-dialog-inner col-lg-10 col-12 animate__animated animate__fadeInDown mx-auto"
            onClick={(e) => e.stopPropagation()}
          >
            <p className="ins-dialog-heading text-danger">Payroll Details</p>

            <table className="w-100">
              <tbody>
                <tr className="account-tr">
                  <td colSpan={3}>Employee Id: {selectedEmp.user_id}</td>
                  <td colSpan={3}>Employee Name: {selectedEmp.staff_name}</td>
                </tr>

                <tr className="account-tr">
                  <td colSpan={3}>Employee Role: {selectedEmp.staff_role}</td>
                  <td colSpan={3}>Designation: {selectedEmp.staff_designation}</td>
                </tr>

                <tr className="account-tr">
                  <td colSpan={6}>Salary: ₹{selectedEmp.staff_salary}</td>
                </tr>

                <tr className="account-tr">
                  <td>Present</td>
                  <td>Absent</td>
                  <td>Leave</td>
                  <td>Holiday</td>
                  <td>Half Day</td>
                  <td>%</td>
                </tr>

                <tr className="account-tr">
                  <td>{selectedEmp.present}</td>
                  <td>{selectedEmp.absent}</td>
                  <td>{selectedEmp.leave}</td>
                  <td>{selectedEmp.holiday}</td>
                  <td>{selectedEmp.halfDay}</td>
                  <td>
                    {(
                      ((selectedEmp.present + selectedEmp.holiday + 0.5 * selectedEmp.halfDay) /
                        (selectedEmp.present +
                          selectedEmp.holiday +
                          selectedEmp.absent +
                          selectedEmp.leave +
                          selectedEmp.halfDay)) *
                      100
                    ).toFixed(1)}
                    %
                  </td>
                </tr>
              </tbody>
            </table>


            {selectedPayroll.earning && selectedPayroll.earning.length > 0 && (
          <>
            <h6 className="fw-semibold mt-3">Additional Earnings</h6>
            <table className="table table-bordered mt-2">
              <thead>
                <tr>
                  <th>Description</th>
                  <th>Amount (₹)</th>
                </tr>
              </thead>
              <tbody>
                {selectedPayroll.earning.map((item, index) => (
                  <tr key={index}>
                    <td>{item.description}</td>
                    <td>₹{item.amount}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </>
        )}

        {/* Deduction Section */}
        {selectedPayroll.deduction && selectedPayroll.deduction.length > 0 && (
          <>
            <h6 className="fw-semibold mt-3">Additional Deductions</h6>
            <table className="table table-bordered mt-2">
              <thead>
                <tr>
                  <th>Description</th>
                  <th>Amount (₹)</th>
                </tr>
              </thead>
              <tbody>
                {selectedPayroll.deduction.map((item, index) => (
                  <tr key={index}>
                    <td>{item.description}</td>
                    <td>₹{item.amount}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </>
        )}

<p className='mt-4'>Generated On {formatDate(selectedPayroll.generated_on)}<br />Payroll: {selectedPayroll.month} {selectedPayroll.year}</p>
<p className='fw-semibold'>Net Salary: ₹{selectedPayroll.net_salary}</p>

            <button className="profile-btn2 mt-4" onClick={() => setShowView(false)}>
              Go Back
            </button>

</div>
</section>

    </>
)}

        </>
    )
}

export default Payroll
